import { Reveal } from "./Reveal";
import { Doodles } from "./Doodles";
import "./Testimonial.css";

export const Testimonial = () => {
    return (
        <section
            className="testimonial"
            id="testimonials"
            data-testid="testimonial-section"
        >
            <Doodles
                items={[
                    {
                        type: "sparkle",
                        color: "blue",
                        size: 24,
                        style: { top: "20%", left: "10%" },
                    },
                    {
                        type: "ring",
                        color: "pink",
                        size: 22,
                        style: { bottom: "18%", right: "10%" },
                        delay: "1s",
                    },
                ]}
            />
            <div className="testimonial-inner">
                <Reveal
                    as="blockquote"
                    className="testimonial-quote"
                    data-testid="testimonial-quote"
                >
                    "We can't wait to see where we will be in 1 year with
                    GrowCo!"
                </Reveal>
                <Reveal
                    as="p"
                    className="testimonial-body"
                    delay={0.1}
                    data-testid="testimonial-body"
                >
                    In just 60 days, our YouTube channel has 10 times
                    ourselves in real-life subscribers to our channel. We have
                    also moved from 6000 views to 55,000 views per day. GrowCo
                    is a wonderful investment and they have rocked our site in
                    such a short time.
                </Reveal>
                <Reveal className="testimonial-attribution" delay={0.15}>
                    <img
                        className="testimonial-avatar"
                        src="/media/radona-headshot.jpg"
                        alt="RaDona Ludlow headshot"
                        data-testid="testimonial-avatar"
                    />
                    <span className="testimonial-attribution-text">
                        <span
                            className="testimonial-name"
                            data-testid="testimonial-name"
                        >
                            RaDona Ludlow
                        </span>
                        <span className="testimonial-role">
                            Boys and Girls Hairstyles, 196K subscribers
                        </span>
                    </span>
                </Reveal>
            </div>
        </section>
    );
};
